import Logo from '@assets/images/Logo_Main.png';
import { IHeaderProps } from '@common/interface';
import { PageId } from '@common/constants';
import './styles.css';
import { routes } from '@routes/index';
import { MenuItem, SubMenuItem } from './interface';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';

const Header = (props: IHeaderProps) => {
	const { pageInfo } = props;
	const navigate = useNavigate();
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const [openSubmenu, setOpenSubmenu] = useState<string | null>(null);

	useEffect(() => {
		if (isMobileMenuOpen) {
			document.body.classList.add('no-scroll');
		} else {
			document.body.classList.remove('no-scroll');
		}

		return () => {
			document.body.classList.remove('no-scroll');
		};
	}, [isMobileMenuOpen]);

	const toggleMobileMenu = () => {
		setIsMobileMenuOpen(!isMobileMenuOpen);
		if (!isMobileMenuOpen) {
			setOpenSubmenu(null);
		}
	};

	const toggleSubmenu = (id: string) => {
		setOpenSubmenu(openSubmenu === id ? null : id);
	};

	const menuItems: MenuItem[] = [
		{ id: PageId.Homepage },
		// { id: PageId.ActiveEvent1 },
		// { id: PageId.ActiveEvent2 },
		{
			id: PageId.AboutUs,
			subMenu: [
				{
					id: PageId.MissionVision,
					label: 'Vission & Mission',
				},
				{
					id: PageId.BoardOfAdvisors,
					label: 'Board of Advisors',
				},
				{
					id: PageId.ExecutiveCouncil,
					label: 'Executive Council Office Bearers',
				},
				{
					id: PageId.IndustrialExpertAdvisory,
					label: 'Industrial Expert Advisory Committee',
				},
				{
					id: PageId.TAAConstitution,
					label: 'TAA Constitution',
					link: '/docs/TAA_Constituition.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
			],
		},
		{
			id: PageId.Events,
			subMenu: [
				{
					id: PageId.EventsGallery,
					label: 'Events Gallery',
				},
				{
					id: PageId.Video,
					label: 'Video',
				},
				{
					id: PageId.Homecoming,
					label: 'Homecoming',
				},
			],
		},
		{
			id: PageId.News,
			subMenu: [
				{
					id: PageId.CallToReform,
					label: 'Call To Reform',
				},
				{
					id: PageId.TAAEducationTrust,
					label: 'TAA Education Trust',
				},
				{
					id: PageId.NewsRelease,
					label: 'News Release',
				},
				{
					id: PageId.NewsClippings,
					label: 'News Clippings',
				},
				{
					id: PageId.AlumniNewsClippings,
					label: 'Alumni News Clippings',
				},
			],
		},
		{
			id: PageId.AGM,
			label: 'AGM',
			subMenu: [
				{
					id: 'Notice of 13th AGM',
					label: 'Notice of 13th AGM',
					link: '/docs/13th_AGM_Notice.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
				{
					id: 'Notice of 12th AGM',
					label: 'Notice of 12th AGM',
					link: '/docs/12th_AGM_Notice.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
				{
					id: 'Notice of 11th AGM',
					label: 'Notice of 11th AGM',
					link: '/docs/11th_AGM_Notice.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
				{
					id: 'Notice of 10th AGM',
					label: 'Notice of 10th AGM',
					link: '/docs/10th_AGM_Notice.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
				{
					id: 'Notice of 9th AGM',
					label: 'Notice of 9th AGM',
					link: '/docs/9th_AGM_Notice.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
				{
					id: 'Notice of 8th AGM',
					label: 'Notice of 8th AGM',
					link: '/docs/8th_AGM_Notice.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
				{
					id: 'Notice of 7th AGM',
					label: 'Notice of 7th AGM',
					link: '/docs/7th_AGM_Notice.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
				{
					id: 'Notice of 6th AGM',
					label: 'Notice of 6th AGM',
					link: '/docs/6th_AGM_Notice.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
				{
					id: 'Notice of 5th AGM',
					label: 'Notice of 5th AGM',
					link: '/docs/5th_AGM_Notice.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
				{
					id: 'Notice of 4th AGM',
					label: 'Notice of 4th AGM',
					link: '/docs/4th_AGM_Notice.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
				{
					id: 'Notice of 3rd AGM',
					label: 'Notice of 3rd AGM',
					link: '/docs/3rd_AGM_Notice.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
				{
					id: 'Notice of 2nd AGM',
					label: 'Notice of 2nd AGM',
					link: '/docs/2nd_AGM_Notice.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
				{
					id: 'Notice of 1st AGM',
					label: 'Notice of 1st AGM',
					link: '/docs/1st_AGM_Notice.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
			],
		},
		{
			id: PageId.AuditedReport,
			label: 'Audited Report',
			subMenu: [
				{
					id: 'Audited Report 2024',
					label: 'Audited Report 2024',
					link: '/docs/Audited_Report_2024.pdf',
					target: '_blank',
					rel: 'noreferrer',
				},
			],
		},
		{
			id: PageId.Membership,
			subMenu: [
				{
					id: PageId.JoinUs,
					label: 'Join Us',
				},
				{
					id: PageId.TAAPrivacyPolicy,
					label: 'TAA Privacy Policy',
				},
			],
		},
		{ id: PageId.TCCI },
		// { id: PageId.TARUCTAAScholarships },
		{
			id: PageId.RegionalCharter,
			subMenu: [
				{
					id: PageId.SouthCharter,
					label: 'South Charter',
				},
			],
		},
		{
			id: PageId.ContactUs,
			subMenu: [
				// {
				// 	id: PageId.Donation,
				// 	label: 'Donation',
				// },
				{
					id: 'Make A Gift',
					label: 'Make A Gift',
					link: '/images/DonationAppealLetter.jpg',
					target: '_blank',
					rel: 'noreferrer',
				},
			],
		},
	].map(item => {
		const route = routes.find(route => route.page.selfId === item.id);
		const mappedItem: MenuItem = {
			...item,
			header: route?.header,
			label: route?.title || item.label || item.id,
			link: route?.path || undefined,
		};

		if (mappedItem.subMenu) {
			mappedItem.subMenu = mappedItem.subMenu.map(subItem => {
				if (subItem.link) return subItem; // Skip if link is already defined
				const subRoute = routes.find(route => route.page.selfId === subItem.id);
				return {
					...subItem,
					header: subRoute?.header,
					label: subRoute?.title || subItem.label || subItem.id,
					link: subRoute?.path || undefined,
				};
			});
		}

		return mappedItem;
	});

	let currentPage: MenuItem | SubMenuItem | null = null;

	currentPage = menuItems.reduce<MenuItem | SubMenuItem | null>((found, item) => {
		if (found) return found;

		if (item.subMenu) {
			const subItem = item.subMenu.find(sub => sub.id === pageInfo.selfId);
			if (subItem) return subItem;
		}

		return item.id === pageInfo.selfId ? item : null;
	}, null);

	return (
		<>
			<div className="header">
				<div className="header-container">
					<div className="header-logo">
						<img src={Logo} alt="TARCian Alumni Association" onClick={() => navigate('/')} />
					</div>

					<button className="mobile-menu-button" onClick={toggleMobileMenu}>
						<span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}></span>
					</button>

					<nav className={`header-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
						<div className="header-nav-container">
							{menuItems.map((item, index) => (
								<div key={index} className={`nav-item ${openSubmenu === item.id ? 'active' : ''}`}>
									<div className="nav-link-container">
										<a
											href={item.link || '#'}
											className={`nav-link ${item.id === pageInfo.parentId ? 'active' : ''}`}
											onClick={() => setIsMobileMenuOpen(false)}
										>
											{item.label}
										</a>
										{item.subMenu && (
											<button
												className="submenu-toggle"
												onClick={e => {
													e.preventDefault();
													toggleSubmenu(item.id);
												}}
											>
												<span className="submenu-arrow">▼</span>
											</button>
										)}
									</div>
									{item.subMenu && (
										<div className={`dropdown-menu ${openSubmenu === item.id ? 'show' : ''}`}>
											{item.subMenu?.map(subItem => (
												<a
													key={subItem.id}
													href={subItem.link || '#'}
													rel={subItem.rel}
													target={subItem.target}
													className="dropdown-item"
													onClick={() => {
														setIsMobileMenuOpen(false);
														setOpenSubmenu(null);
													}}
												>
													{subItem.label}
												</a>
											))}
										</div>
									)}
								</div>
							))}
						</div>
					</nav>
				</div>
			</div>
			{currentPage && currentPage.id !== PageId.Homepage && (
				<div className="page-title-banner">
					<div className="page-title-container">
						<h1>{currentPage.header || currentPage.label}</h1>
					</div>
				</div>
			)}
		</>
	);
};

export default Header;
